import React, {useEffect, useState} from "react";
import './App.css';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import {ThemeProvider} from "@material-ui/styles";
import {AppContext} from "./AppContext";
import {createMuiTheme, CssBaseline, Snackbar} from "@material-ui/core";
import AppStateProvider from "./components/twilio/state";
import EventShowPage from "./components/EventShowPage";
import firebase from "firebase/app";
import 'firebase/auth';
import Home from "./components/Home";
import AllEvents from "./components/AllEvents";
import FirebaseAuth from "./components/FirebaseAuth";
import {MessageContext} from "./MessageContext";
import {Alert} from "@material-ui/lab";
import CreateEvent from "./components/CreateEvent";
import NavBar from "./components/NavBar";
import Profile from "./components/Profile";
import GameInterface from "./components/GameInterface";
import LandingPage from "./components/LandingPage";
import Copyright from "./Copyright";
import AdminHome from "./components/AdminHome";
import AdminEvent from "./components/admin/AdminEvent";
import ManageAttendees from "./components/admin/ManageAttendees";
import EventEventBrite from "./components/admin/EventEventBrite";
import EventVenueConfig from "./components/admin/EventVenueConfig";
import ErrorBoundary from "./ErrorBoundary";

export default function AppRoute() {

    const theme = createMuiTheme({
        palette: {
            type: "dark"
        }
    });

    const [audioActive, setAudioActive] = useState(localStorage.getItem('audioActiveLocal') !== 'false',)

    useEffect(() => {
        localStorage.setItem('audioActiveLocal', audioActive ? 'true' : 'false');
    }, [audioActive])

    const toggleAudioActive = () => setAudioActive(!audioActive)

    const [currentEvent, setCurrentEvent] = useState(null)
    const [currentUser, setCurrentUser] = useState(null)
    const [readyForAuth, setReadyForAuth] = useState(false)
    const [showMessage, setShowMessage] = useState(false)
    const [messageSuccess, setMessageSuccess] = useState(false)
    const [showMessageString, setShowMessageString] = useState(null)

    const sendLogout = () => {
        fetch(`${process.env.REACT_APP_API_CALL}/logout`, {
            method: "POST",
            credentials: 'include'
        })
    }

    const logout = () => {
        firebase.auth().signOut().then(() => {
            setCurrentEvent(null)
            setCurrentUser(null)
            setReadyForAuth(false)
            sendLogout()
            document.location = "/"
        })
    }

    const appContext = {
        currentUser: currentUser,
        updateLocalUser: setCurrentUser,
        logout: logout,
        selectCurrentEvent: setCurrentEvent,
        audioActive: audioActive,
        toggleAudioActive: toggleAudioActive
    }

    const messageContext = {
        showSuccessMessage: (message) => {
            setShowMessage(true)
            setMessageSuccess(true)
            setShowMessageString(message)
        },
        showErrorMessage: (message) => {
            setShowMessage(true)
            setMessageSuccess(false)
            setShowMessageString(message)
        }
    }

    const sendUserToDb = (user, credential) => {
        fetch(`${process.env.REACT_APP_API_CALL}/start`, {
            method: "POST",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                email: user.email,
                name: user.displayName,
                uid: user.uid,
                auth_provider: credential ? credential.providerId : null,
                auth_token: credential ? credential.accessToken : null,
                image_url: user.photoURL
            })
        })
            .then(response => response.json())
            .then(response => {
                if (response.errors) {
                    alert(response.errors)
                } else {
                    setCurrentUser(response.user)
                }
            })
    }

    useEffect(() => {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                sendUserToDb(user)
            } else {
                setReadyForAuth(true)
            }
        })
    }, [])

    return (
        <ErrorBoundary>
            <Router>
                <AppStateProvider>
                    <ThemeProvider theme={theme}>
                        <MessageContext.Provider value={messageContext}>
                            <>
                                <div className="App-body">
                                    {currentUser &&
                                    <AppContext.Provider value={appContext}>
                                        <CssBaseline/>

                                        <NavBar currentEvent={currentEvent}/>
                                        <div className="App-content">
                                            <Switch>
                                                <Route path="/allEvents" children={<AllEvents/>}/>
                                                <Route path="/createEvent" children={<CreateEvent/>}/>
                                                <Route path="/profile" children={<Profile/>}/>
                                                <Route path="/game/:eventId" children={<GameInterface updateCurrentEvent={setCurrentEvent}/>}/>
                                                <Route path="/events/:eventId" children={<EventShowPage updateCurrentEvent={setCurrentEvent}/>}/>
                                                <Route path="/admin/event/:eventId/manage-attendees" children={<ManageAttendees />}/>
                                                <Route path="/admin/event/:eventId/manage-eventbrite" children={<EventEventBrite />}/>
                                                <Route path="/admin/event/:eventId" children={<AdminEvent />}/>
                                                <Route path="/admin/eventvenue/:eventId" children={<EventVenueConfig/>}/>
                                                <Route path="/admin_home" children={<AdminHome/>}/>

                                                <Route path="/">
                                                    <Home/>
                                                </Route>
                                            </Switch>
                                        </div>

                                    </AppContext.Provider>
                                    }
                                    {(!currentUser && readyForAuth) &&
                                    <div id="landing-page">
                                        <LandingPage/>
                                        <FirebaseAuth sendUserToDb={sendUserToDb}/>
                                        <img src={"/assets/smalldog.png"}/>
                                        <Copyright/>
                                    </div>
                                    }
                                </div>
                            </>
                            <Snackbar open={showMessage} autoHideDuration={3000}
                                      onClose={() => setShowMessage(false)}>
                                <Alert severity={messageSuccess ? "success" : "error"} variant="filled">
                                    {showMessageString}
                                </Alert>
                            </Snackbar>
                        </MessageContext.Provider>
                    </ThemeProvider>
                </AppStateProvider>
            </Router>
        </ErrorBoundary>
    );
}
